"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var router_1 = require("@angular/router");
var core_1 = require("@angular/core");
var services_1 = require("../../services");
var AppComponent = (function () {
    function AppComponent(route, eventService, userService) {
        this.route = route;
        this.eventService = eventService;
        this.userService = userService;
    }
    AppComponent.prototype.hideModals = function ($event) {
        if ($event && $event.keyCode !== 27) {
            if ($event.keyCode === 8) {
                $event.preventDefault();
            }
            return;
        }
        this.eventService.fire('hideModals');
    };
    AppComponent.prototype.syncOnFocus = function () {
        this.userService.sync();
    };
    AppComponent.prototype.ngOnInit = function () {
        this.subscribeOnEvents();
    };
    AppComponent.prototype.ngOnDestroy = function () {
        this.unSubscribeFromEvents();
    };
    AppComponent.prototype.subscribeOnEvents = function () {
        var _this = this;
        this.subscriptionHideScrollEvent
            = this.eventService.subscribe('hideScroll', function () { return _this.hideScroll(); });
        this.subscriptionShowScrollEvent
            = this.eventService.subscribe('showScroll', function () { return _this.showScroll(); });
    };
    AppComponent.prototype.unSubscribeFromEvents = function () {
        this.subscriptionHideScrollEvent.unsubscribe();
        this.subscriptionShowScrollEvent.unsubscribe();
    };
    AppComponent.prototype.hideScroll = function () {
        document.body.classList.add('scroll-hidden');
    };
    AppComponent.prototype.showScroll = function () {
        document.body.classList.remove('scroll-hidden');
    };
    return AppComponent;
}());
__decorate([
    core_1.HostListener('document:keydown', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [KeyboardEvent]),
    __metadata("design:returntype", void 0)
], AppComponent.prototype, "hideModals", null);
__decorate([
    core_1.HostListener('window:focus'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AppComponent.prototype, "syncOnFocus", null);
AppComponent = __decorate([
    core_1.Component({
        selector: 'app-component',
        template: require('./app.component.pug'),
        styles: [require('./app.component.scss')]
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        services_1.EventService,
        services_1.UserService])
], AppComponent);
exports.AppComponent = AppComponent;



//////////////////
// WEBPACK FOOTER
// ./src/components/app/app.component.ts
// module id = 240
// module chunks = 0